import { Typography, Box, type BoxProps } from "@mui/material";
import React from "react";

import { ExternalLink } from "src/components/ExternalLink";
import { EmeriaUrl } from "src/constants";
import { useBrand } from "src/hooks/useBrand";

export const LegalInfo = (props: BoxProps) => {
  const { identity, dataProtectionPolicy } = useBrand();

  return (
    <Box {...props}>
      <Typography>
        Les données à caractère personnel recueillies par {identity.name}, responsable du
        traitement, filiale d'
        <ExternalLink href={EmeriaUrl}>Emeria Europe</ExternalLink>, font l'objet d'un traitement
        automatisé pour les besoins de la gestion des biens immobiliers et du suivi client. Ces
        données peuvent être transmises, le cas échéant, aux filiales d’
        <ExternalLink href={EmeriaUrl}>Emeria Europe</ExternalLink> uniquement dans le cadre de
        l'exécution du contrat ainsi qu'à ses sous-traitants dans le cadre de la prestation de
        services.
      </Typography>
      <Typography>
        Elles seront conservées durant toute la durée de la relation commerciale et pendant une
        durée maximale de 5 ans à compter de la fin de la relation commerciale, conformément à
        l'article 2224 du Code civil et à l'article L561-12 du Code monétaire et financier, relatif
        à l’obligation de conservation des informations des clients dans le cadre de la lutte contre
        le blanchiment de capitaux et le financement du terrorisme, sauf si une durée de
        conservation plus courte est requise par la législation applicable. Les registres légaux
        tenus par {identity.name} doivent être conservés pendant 10 ans (articles 53, 65 et 72 du
        décret du 20 juillet 1972).
      </Typography>
      <Typography>
        Conformément à la loi n°78-17 du 6 janvier 1978 dans sa version en vigueur et au Règlement
        européen (UE) 2016/679 (RGPD), vous disposez d'un droit d'accès, d’opposition, de
        rectification, de portabilité, de limitation et de suppression des informations vous
        concernant. Vous pouvez facilement exercer vos droits sans frais en contactant le Délégué à
        la protection des données (DPO) via un formulaire dédié en{" "}
        <ExternalLink href={dataProtectionPolicy.formUrl}>cliquant ici</ExternalLink>.
      </Typography>
      <Typography>
        {`${identity.name} : Société par actions simplifiée unipersonnelle au capital de 43\u00A0416\u00A0652,00\u00A0€ dont le siège social est à Courbevoie (92400) – Liberty Tower, 17 place des Reflets, immatriculée au Registre du Commerce et des Sociétés de Nanterre sous le numéro 484\u00A0882\u00A0642.`}
      </Typography>
    </Box>
  );
};
